import React from 'react';
import { setDisplayName, wrapDisplayName } from 'recompose';

import metrics from './metrics';

const withMetrics = (WrappedComponent) => {
  const WithMetrics = props => (
    <WrappedComponent
      {...props}
      metrics={metrics}
    />
  );

  return setDisplayName(wrapDisplayName(WrappedComponent, 'WithMetrics'))(WithMetrics);
};

export default withMetrics;
